<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">Wiadomości z formularza współpracy</h4>
          </md-card-header>
          <md-card-content>
            <md-table v-model="list">
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="ID">{{ item.id }}</md-table-cell>
                <md-table-cell md-label="Email">{{ item.email }}</md-table-cell>
                <md-table-cell md-label="Imię">{{ item.firstName }}</md-table-cell>
                <md-table-cell md-label="Nazwisko">{{ item.lastName }}</md-table-cell>
                <md-table-cell md-label="Przeczytane">{{ item.isRead ? "tak" : "nie" }}</md-table-cell>
                <md-table-cell md-label="Akcje">
                  <router-link :to="`/cooperation/${item.id}`">
                    <md-button class="md-primary">Zobacz</md-button>
                  </router-link>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
      <!-- <div class="md-layout-item md-size-100">
        
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "CooperationList",
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.getCooperationOffers();
  },
  methods: {
    async getCooperationOffers() {
      return await this.$axios
        .get(`/cooperation`)
        .then((res) => {
          this.list = res.data;
        })
        .catch((error) => {
          this.list = [];
        });
    },
  },
};
</script>
